module.exports = __webpack_public_path__ + "media/images/athletes/1604-712b42189a34fb75586d5c8da79ef224.png";